import axios from "axios";

// Function to retrieve the token (you can modify this to fit your token storage logic)
const getAuthToken = () => {
    return localStorage.getItem("token");
};

const ADMIN_API_BASE_URL = "http://188.166.214.1:3000/api/admin";
const BANK_API_BASE_URL = "http://188.166.214.1:3000/api/bank-accounts";
const SENDER_BANK_API_BASE_URL =
    "http://188.166.214.1:3000/api/sender-bank-accounts";
const TRADER_API_BASE_URL = "http://188.166.214.1:3000/api/traders";
const TRADE_API_BASE_URL = "http://188.166.214.1:3000/api/trades";
const BANK_STAT_API_BASE_URL = "http://188.166.214.1:3000/api/back-account-daily-status"

// Function to add Authorization headers
const getHeaders = () => {
    const token = getAuthToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
};

const adminApi = {
    loginAdmin: async (credentials) =>
        (await axios.post(`${ADMIN_API_BASE_URL}/login`, credentials)).data, // No token here
    getAdminInfo: async () =>
        (
            await axios.get(`${ADMIN_API_BASE_URL}/info`, {
                headers: getHeaders(),
            })
        ).data,
    createAdmin: async (adminData) =>
        (
            await axios.post(`${ADMIN_API_BASE_URL}/create`, adminData, {
                headers: getHeaders(),
            })
        ).data,
    getAdmins: async (page = 1, limit = 10) =>
        (
            await axios.get(`${ADMIN_API_BASE_URL}`, {
                headers: getHeaders(),
                params: { page, limit },
            })
        ).data,
    getAdminById: async (id) =>
        (
            await axios.get(`${ADMIN_API_BASE_URL}/${id}`, {
                headers: getHeaders(),
            })
        ).data,
    updateAdmin: async (id, updateData) =>
        (
            await axios.put(`${ADMIN_API_BASE_URL}/${id}`, updateData, {
                headers: getHeaders(),
            })
        ).data,
    deleteAdmin: async (id) =>
        (
            await axios.delete(`${ADMIN_API_BASE_URL}/${id}`, {
                headers: getHeaders(),
            })
        ).data,
};

const bankAccountApi = {
    createBankAccount: async (bankData) =>
        (
            await axios.post(`${BANK_API_BASE_URL}/create`, bankData, {
                headers: getHeaders(),
            })
        ).data,
    getBankAccounts: async (page = 1, limit = 10) =>
        (
            await axios.get(`${BANK_API_BASE_URL}`, {
                headers: getHeaders(),
                params: { page, limit },
            })
        ).data,
    getBankAccountById: async (id) =>
        (
            await axios.get(`${BANK_API_BASE_URL}/${id}`, {
                headers: getHeaders(),
            })
        ).data,
    updateBankAccount: async (id, updateData) =>
        (
            await axios.put(`${BANK_API_BASE_URL}/${id}`, updateData, {
                headers: getHeaders(),
            })
        ).data,
    deleteBankAccount: async (id) =>
        (
            await axios.delete(`${BANK_API_BASE_URL}/${id}`, {
                headers: getHeaders(),
            })
        ).data,
};

const senderBankAccountApi = {
    createSenderBankAccount: async (senderBankData) =>
        (
            await axios.post(
                `${SENDER_BANK_API_BASE_URL}/create`,
                senderBankData,
                { headers: getHeaders() }
            )
        ).data,
    getSenderBankAccounts: async (page = 1, limit = 10) =>
        (
            await axios.get(`${SENDER_BANK_API_BASE_URL}`, {
                headers: getHeaders(),
                params: { page, limit },
            })
        ).data,
    getSenderBankAccountById: async (id) =>
        (
            await axios.get(`${SENDER_BANK_API_BASE_URL}/${id}`, {
                headers: getHeaders(),
            })
        ).data,
    updateSenderBankAccount: async (id, updateData) =>
        (
            await axios.put(`${SENDER_BANK_API_BASE_URL}/${id}`, updateData, {
                headers: getHeaders(),
            })
        ).data,
    deleteSenderBankAccount: async (id) =>
        (
            await axios.delete(`${SENDER_BANK_API_BASE_URL}/${id}`, {
                headers: getHeaders(),
            })
        ).data,
};

const traderApi = {
    createTrader: async (traderData) =>
        (
            await axios.post(`${TRADER_API_BASE_URL}/create`, traderData, {
                headers: getHeaders(),
            })
        ).data,
    getTraders: async (page = 1, limit = 10) =>
        (
            await axios.get(`${TRADER_API_BASE_URL}`, {
                headers: getHeaders(),
                params: { page, limit },
            })
        ).data,
    getTraderById: async (id) =>
        (
            await axios.get(`${TRADER_API_BASE_URL}/${id}`, {
                headers: getHeaders(),
            })
        ).data,
    updateTrader: async (id, updateData) =>
        (
            await axios.put(`${TRADER_API_BASE_URL}/${id}`, updateData, {
                headers: getHeaders(),
            })
        ).data,
    deleteTrader: async (id) =>
        (
            await axios.delete(`${TRADER_API_BASE_URL}/${id}`, {
                headers: getHeaders(),
            })
        ).data,
};

const tradeApi = {
    createTrade: async (tradeData) =>
        (
            await axios.post(`${TRADE_API_BASE_URL}/create`, tradeData, {
                headers: getHeaders(),
            })
        ).data,
    getTrades: async (page = 1, limit = 10) =>
        (
            await axios.get(`${TRADE_API_BASE_URL}`, {
                headers: getHeaders(),
                params: { page, limit },
            })
        ).data,
    getTradeById: async (id) =>
        (
            await axios.get(`${TRADE_API_BASE_URL}/${id}`, {
                headers: getHeaders(),
            })
        ).data,
    updateTrade: async (id, updateData) =>
        (
            await axios.put(`${TRADE_API_BASE_URL}/${id}`, updateData, {
                headers: getHeaders(),
            })
        ).data,
    deleteTrade: async (id) =>
        (
            await axios.delete(`${TRADE_API_BASE_URL}/${id}`, {
                headers: getHeaders(),
            })
        ).data,
    getDailyReport: async (date) =>
        (
            await axios.get(
                `${TRADE_API_BASE_URL}/stats/daily-report?date=${date}`,
                {
                    headers: getHeaders(),
                }
            )
        ).data,
};

const bankAccountStatusApi = {
    getDailyStatus: async (date) =>
        (
            await axios.get(
                `${BANK_STAT_API_BASE_URL}/bank-daily-status?date=${date}`,
                {
                    headers: getHeaders(),
                }
            )
        ).data,
};

export { adminApi, bankAccountApi, senderBankAccountApi, traderApi, tradeApi, bankAccountStatusApi };
